import { request } from "./api"

export const SESSION_ACTIVITY_URL = "/auth/session-activity/"

export const pingSessionActivity = () =>
  request.api.post(SESSION_ACTIVITY_URL, {})
